import { RoleType } from '@csp/dmdp-api-common-dto';
import { ClientType, CspError } from '@csp/csp-common-model';
import { ContentRole } from '../models/ContentRole';

const hcpContentRoles = [
  RoleType.CRA,
  RoleType.PI,
  RoleType.INVESTIGATOR,
  RoleType.STUDY_ASST,
  RoleType.READ_ALL,
  RoleType.SSTM,
  RoleType.GSTM,
  RoleType.SERVICE_CSA,
  RoleType.SUPPORT_MANAGE,
];

const patientContentRoles = [RoleType.PATIENT, RoleType.SERVICE_CSA, ...hcpContentRoles];

const isHcpContentRole = (roleTypes: RoleType[]): boolean =>
  hcpContentRoles.some(role => roleTypes.find(r => r) === role);

const isPatientContentRole = (roleTypes: RoleType[]): boolean =>
  patientContentRoles.some(role => roleTypes.find(r => r) === role);

export const getContentRole = (roleTypes: RoleType[]): ContentRole[] => {
  const roles: ContentRole[] = [];

  if (isHcpContentRole(roleTypes)) {
    roles.push('hcp');
  }
  if (isPatientContentRole(roleTypes)) {
    roles.push('patient');
  }
  return roles;
};

export const getContentRoleFromClientType = (clientType: ClientType): ContentRole => {
  switch (clientType) {
    case ClientType.HCP_WEB:
      return 'hcp';
    case ClientType.PATIENT_WEB:
    case ClientType.PATIENT_APP:
      return 'patient';
    default:
      throw CspError.internal(
        `Missing client type to content role mapping, could not resolve ${clientType} to a content role`,
      );
  }
};
